//resources/js/App.jsx
import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { route } from 'ziggy-js'; 
import { initBackButtonHandler } from '@/bootstrap/exitOnBack';

window.route = route;

const appName = 'Agasaja Academy';

/*/ --- BLOQUE DE TRADUCCIONES (NECESARIO) ---*/
if (typeof window.__ === 'undefined') {
    // Definimos el helper global que Laravel espera
    window.__ = (key) => {
        // En una aplicación real, se buscaría la key en un objeto de mensajes global si estuviera disponible.
        // Por ahora, solo devolvemos la key como fallback seguro
        return key; 
    };
}

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.jsx`,
            import.meta.glob('./Pages/**/*.jsx'),
        ),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(<App {...props} />);
    },
    progress: {
        color: '#4B5563',
    },
});

initBackButtonHandler(); // para resolver el problema de back history

if ('serviceWorker' in navigator) {

    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then(reg => console.log('Service Worker registrado para Agasaja', reg))
            .catch(err => console.log('Error al registrar SW', err));
    });
    
}
